module.exports = __webpack_public_path__ + "static/media/SuperShuttle_ios_2.f700af8e.jpg";